module.exports = __webpack_public_path__ + "static/media/self2.960d2fab.jpg";